<template>
<LoadingScreen/>
<HeaderComponent/>
<ModalFlora/>
<ModalFauna/>
<!--<ModalSecondary/>-->
<ModalTertiary/>
<ModalQuinquenary/>
  <a-scene renderer="antialias: true; colorManagement: true;" vr-mode-ui="enabled: false">
    <a-assets>
      <a-asset-item id="gltf-test" src="/models/escenario_esfera.glb"></a-asset-item>
    </a-assets>

      <a-entity camera look-controls position="0 0 0"></a-entity>
      <a-entity 
        id="mouse_cursor"
        cursor="rayOrigin:mouse;fuseTimeout:0"
        raycaster="objects: [data-raycastable]"></a-entity>
      
      <a-entity gltf-model="url(/models/escenario_esfera.glb)" position="0 0 0" scale="1 1 1" animation-mixer data-raycastable main></a-entity>
      
  </a-scene>
<BottomBar/>
</template>

<script>
/* eslint-disable */
import HeaderComponent from '@/components/Header.vue';
import '@/helpers/aframe-components'
import ModalFlora from './components/ModalFlora.vue';
import ModalFauna from './components/ModalFauna.vue';
import ModalSecondary from '@/components/ModalSecondary.vue';
import ModalTertiary from '@/components/ModalTertiary.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import BottomBar from './components/BottomBar.vue';
import {useMainStore} from '@/stores/mainStore';
import ModalQuinquenary from './components/ModalQuinquenary.vue';


export default {
  name: 'App',
  components: {
    HeaderComponent,
    ModalFlora,
    ModalFauna,
    ModalSecondary,
    LoadingScreen,
    ModalTertiary,
    BottomBar,
    ModalQuinquenary
},
setup(){
  const mainStore = useMainStore();
  document.addEventListener('DOMContentLoaded', function() {
    var scene = document.querySelector('a-scene');
    scene.addEventListener('loaded', function(e) {
      mainStore.isLoaded = true;
    });
  });
  return { mainStore }
},
methods:{
  toggleSound: function(){
    console.log(this.mainStore.isMuted)
    if(this.mainStore.isMuted === true){
      this.mainStore.isMuted = false;
      document.getElementById('ambient_audio').play();
    }else if(this.mainStore.isMuted === false){
      this.mainStore.isMuted = true;
      document.getElementById('ambient_audio').pause();
    }
  }
},
mounted(){
  this.mainStore.windowWidth = window.innerWidth;
}
}
</script>

<style>
*{margin: 0;padding: 0;box-sizing: border-box;}

.close{
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgBpdMxDoIwFAbg914MunoDr+ARiBdwdTDoCZgcmGRzUM9gjDGuegDDVTiCbAbwVTsgBoFX4N/62n5pm1cMzjsX4uRmL70QOiS47Nes0oiY1VBZvSA4bEbQMhpTzAtCvqIu3E9bHwkcjFO76UkzDOmzd+aFmE20QYuYruHvgiZoGfYHmqJVWCkooXVYJViFSlgtWERhYDkSJoI5ii6AekiYDkkg9Uh9B08QUwvmb5aMFcPR5EehjOXXNGkpNMWySCg2wUxQbIpJKLbB6lBsi1Wh2AUrQ4lfHHXBdCbzla/7lPs0fQOYyBntVA6JnAAAAABJRU5ErkJggg==');
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: cover;
  align-self: flex-end;
  margin: 15px;
  padding: 12px;/*correction*/
  z-index: 10;
}
.st0{fill:#2B282C;}
.st1{fill:none;stroke:#FFFFFF;stroke-width:4.1457;stroke-linecap:square;stroke-linejoin:round;}
.st2{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:square;stroke-linejoin:round;}
.st3{fill:none;stroke:#2B282C;stroke-width:4.1457;stroke-linecap:square;stroke-linejoin:round;}
</style>
